var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessagesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1369 18.0736C14.359 17.8947 16.9166 15.2253 16.9166 11.9584C16.9166 8.57573 14.1744 5.8335 10.7917 5.8335C7.40898 5.8335 4.66675 8.57573 4.66675 11.9584C4.66675 13.1637 5.01479 14.2876 5.616 15.2352L5.18314 16.5338L5.18245 16.5357C5.01666 17.0331 4.93373 17.2819 4.99278 17.4475C5.04424 17.5918 5.15846 17.7055 5.30277 17.757C5.46781 17.8159 5.71487 17.7335 6.2089 17.5688L6.21593 17.5667L7.51489 17.1338C8.46248 17.735 9.58646 18.0832 10.7918 18.0832C10.9076 18.0832 11.0226 18.08 11.1369 18.0736ZM11.1369 18.0736C11.137 18.0739 11.1368 18.0734 11.1369 18.0736ZM11.1369 18.0736C11.9749 20.4577 14.2463 22.1668 16.9168 22.1668C18.1221 22.1668 19.2458 21.8184 20.1933 21.2171L21.492 21.65L21.4945 21.6505C21.9918 21.8163 22.2411 21.8993 22.4067 21.8403C22.551 21.7888 22.6637 21.6751 22.7152 21.5308C22.7743 21.3649 22.6916 21.1158 22.5254 20.6171L22.0925 19.3185L22.2375 19.0783C22.7494 18.1834 23.041 17.1466 23.041 16.0417C23.041 12.659 20.2993 9.91679 16.9166 9.91679L16.6873 9.92101L16.5717 9.92667",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesIcon);
export default __webpack_public_path__ + "static/media/messages-icon.efa3207a6f43c6ef2567e0b8e09f5060.svg";
export { ForwardRef as ReactComponent };